<template>
  <div class="col responsive-width">
    <div class="container-fluid">
      <div class="content">
        <authorization-banner />
        <div class="headers d-flex">
          <div>
            <h1 class="mb-0">
              {{ $services.helpers.capitalizeNames($t("products")) }}
            </h1>
            <span>{{ PRODUCT_ARTICLES.length }} {{ $t("products") }}</span>
          </div>

          <router-link :to="{ name: 'addproductbasic' }" class="ms-auto">
            <svg
              width="31"
              height="30"
              viewbox="0 0 31 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.6541 0C27.7541 0 30.6641 2.88 30.6641 7.995V22.005C30.6641 27.09 27.7691 30 22.6691 30H8.65906C3.54406 30 0.664062 27.09 0.664062 22.005V7.995C0.664062 2.88 3.54406 0 8.65906 0H22.6541ZM15.6491 8.265C14.9591 8.265 14.4041 8.82 14.4041 9.51V13.74H10.1591C9.82906 13.74 9.51406 13.875 9.27406 14.1C9.04906 14.34 8.91406 14.6535 8.91406 14.985C8.91406 15.675 9.46906 16.23 10.1591 16.245H14.4041V20.49C14.4041 21.18 14.9591 21.735 15.6491 21.735C16.3391 21.735 16.8941 21.18 16.8941 20.49V16.245H21.1541C21.8441 16.23 22.3991 15.675 22.3991 14.985C22.3991 14.295 21.8441 13.74 21.1541 13.74H16.8941V9.51C16.8941 8.82 16.3391 8.265 15.6491 8.265Z"
                fill="#7754FB"
              ></path>
            </svg>
          </router-link>
          <button
            class="btn btn-outline-primary sync-btn"
            v-on:click="syncProduct"
          >
            <i
              class="bx bx-refresh bx-xs"
              :class="{ 'bx-spin': syncing === true }"
            ></i>
          </button>
        </div>
        <nav>
          <div class="row">
            <div class="col">
              <ul class="list-unstyled d-flex">
                <li
                  @click="filterArticle('All')"
                  :class="selectedFilter === 'All' ? 'active-filter' : ''"
                  class="all"
                >
                  {{ $t("all") }}
                </li>
                <li
                  @click="filterArticle('True')"
                  :class="selectedFilter === 'True' ? 'active-filter' : ''"
                  class="enabled"
                >
                  {{ $t("active_resources") }}
                </li>
                <li
                  @click="filterArticle('False')"
                  :class="selectedFilter === 'False' ? 'active-filter' : ''"
                  class="inactive"
                >
                  {{ $t("inactivated_resources") }}
                </li>
              </ul>
            </div>
            <div class="col">
              <div class="right-parent">
                <div class="d-flex flex-wrap align-items-center">
                  <div class="search">
                    <label for="search">
                      <svg
                        width="15"
                        height="15"
                        viewbox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.6219 13.5596L10.0568 8.99453C10.7652 8.07871 11.1484 6.95898 11.1484 5.78125C11.1484 4.37148 10.5982 3.04961 9.60332 2.05293C8.6084 1.05625 7.28301 0.507812 5.875 0.507812C4.46699 0.507812 3.1416 1.05801 2.14668 2.05293C1.15 3.04785 0.601562 4.37148 0.601562 5.78125C0.601562 7.18926 1.15176 8.51465 2.14668 9.50957C3.1416 10.5063 4.46523 11.0547 5.875 11.0547C7.05273 11.0547 8.1707 10.6715 9.08652 9.96484L13.6516 14.5281C13.6649 14.5415 13.6808 14.5521 13.6983 14.5594C13.7158 14.5666 13.7346 14.5704 13.7535 14.5704C13.7725 14.5704 13.7912 14.5666 13.8087 14.5594C13.8262 14.5521 13.8421 14.5415 13.8555 14.5281L14.6219 13.7635C14.6353 13.7501 14.6459 13.7342 14.6531 13.7167C14.6604 13.6992 14.6641 13.6805 14.6641 13.6615C14.6641 13.6426 14.6604 13.6238 14.6531 13.6063C14.6459 13.5889 14.6353 13.573 14.6219 13.5596ZM8.65938 8.56563C7.91406 9.30918 6.92617 9.71875 5.875 9.71875C4.82383 9.71875 3.83594 9.30918 3.09063 8.56563C2.34707 7.82031 1.9375 6.83242 1.9375 5.78125C1.9375 4.73008 2.34707 3.74043 3.09063 2.99688C3.83594 2.25332 4.82383 1.84375 5.875 1.84375C6.92617 1.84375 7.91582 2.25156 8.65938 2.99688C9.40293 3.74219 9.8125 4.73008 9.8125 5.78125C9.8125 6.83242 9.40293 7.82207 8.65938 8.56563Z"
                          fill="#8F8E94"
                        ></path>
                      </svg>
                    </label>
                    <input
                      @input="searchField"
                      id="search"
                      type="text"
                      :placeholder="$t('search')"
                    />
                  </div>
                  <div class="customize">
                    <a
                      class="d-flex"
                      href="javascript:void(0);"
                      @click="openArticleCustomizationModal = true"
                    >
                      <svg
                        width="14"
                        height="13"
                        viewbox="0 0 14 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.83724 7.2474H1.58724C1.39938 7.2474 1.21921 7.32202 1.08637 7.45486C0.953534 7.5877 0.878906 7.76787 0.878906 7.95573V12.2057C0.878906 12.3936 0.953534 12.5738 1.08637 12.7066C1.21921 12.8394 1.39938 12.9141 1.58724 12.9141H5.83724C6.0251 12.9141 6.20527 12.8394 6.33811 12.7066C6.47094 12.5738 6.54557 12.3936 6.54557 12.2057V7.95573C6.54557 7.76787 6.47094 7.5877 6.33811 7.45486C6.20527 7.32202 6.0251 7.2474 5.83724 7.2474ZM5.12891 11.4974H2.29557V8.66406H5.12891V11.4974ZM12.9206 0.164062H8.67057C8.48271 0.164063 8.30254 0.23869 8.16971 0.371528C8.03687 0.504367 7.96224 0.684534 7.96224 0.872396V5.1224C7.96224 5.31026 8.03687 5.49042 8.16971 5.62326C8.30254 5.7561 8.48271 5.83073 8.67057 5.83073H12.9206C13.1084 5.83073 13.2886 5.7561 13.4214 5.62326C13.5543 5.49042 13.6289 5.31026 13.6289 5.1224V0.872396C13.6289 0.684534 13.5543 0.504367 13.4214 0.371528C13.2886 0.23869 13.1084 0.164063 12.9206 0.164062ZM12.2122 4.41406H9.37891V1.58073H12.2122V4.41406ZM12.9206 9.3724H11.5039V7.95573C11.5039 7.76787 11.4293 7.5877 11.2964 7.45486C11.1636 7.32202 10.9834 7.2474 10.7956 7.2474C10.6077 7.2474 10.4275 7.32202 10.2947 7.45486C10.1619 7.5877 10.0872 7.76787 10.0872 7.95573V9.3724H8.67057C8.48271 9.3724 8.30254 9.44702 8.16971 9.57986C8.03687 9.7127 7.96224 9.89287 7.96224 10.0807C7.96224 10.2686 8.03687 10.4488 8.16971 10.5816C8.30254 10.7144 8.48271 10.7891 8.67057 10.7891H10.0872V12.2057C10.0872 12.3936 10.1619 12.5738 10.2947 12.7066C10.4275 12.8394 10.6077 12.9141 10.7956 12.9141C10.9834 12.9141 11.1636 12.8394 11.2964 12.7066C11.4293 12.5738 11.5039 12.3936 11.5039 12.2057V10.7891H12.9206C13.1084 10.7891 13.2886 10.7144 13.4214 10.5816C13.5543 10.4488 13.6289 10.2686 13.6289 10.0807C13.6289 9.89287 13.5543 9.7127 13.4214 9.57986C13.2886 9.44702 13.1084 9.3724 12.9206 9.3724ZM5.83724 0.164062H1.58724C1.39938 0.164063 1.21921 0.23869 1.08637 0.371528C0.953534 0.504367 0.878906 0.684534 0.878906 0.872396V5.1224C0.878906 5.31026 0.953534 5.49042 1.08637 5.62326C1.21921 5.7561 1.39938 5.83073 1.58724 5.83073H5.83724C6.0251 5.83073 6.20527 5.7561 6.33811 5.62326C6.47094 5.49042 6.54557 5.31026 6.54557 5.1224V0.872396C6.54557 0.684534 6.47094 0.504367 6.33811 0.371528C6.20527 0.23869 6.0251 0.164063 5.83724 0.164062ZM5.12891 4.41406H2.29557V1.58073H5.12891V4.41406Z"
                          fill="#5855D6"
                        ></path>
                      </svg>
                      {{ $t("customize") }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
        <div class="box">
          <div
            :class="[
              'box-responsive',
              `cols-count-${articleCustomizeItem.length + 2}`,
            ]"
          >
            <table>
              <thead>
                <tr>
                  <th width="30" class="text-center">
                    <div class="checkbo">
                      <input
                        type="checkbox"
                        v-model="toggleChangeCheckbox"
                        class="form-check-input"
                        @change="toggleAllCheckbox"
                      />
                    </div>
                  </th>
                  <th
                    v-for="(item, i) in tableHeader"
                    :class="centeredColumns.includes(item) ? 'data-center' : ''"
                    :key="i"
                  >
                    <div style="display: flex">
                      <span>{{
                        $services.helpers.removeUnderscoreAndCapString($t(item))
                      }}</span
                      ><span
                        v-if="!item_to_exclude.includes(item)"
                        class="th-soring"
                      >
                        <i
                          class="bx bx-chevron-up bx-xs el-clickable"
                          v-if="sortableColumns.includes(item)"
                          v-on:click="sortAscBy(i, item)"
                        ></i>
                        <i
                          class="bx bx-chevron-down bx-xs el-clickable"
                          v-if="sortableColumns.includes(item)"
                          v-on:click="sortDescBy(i, item)"
                        ></i>
                      </span>
                    </div>
                  </th>

                  <th width="90"><span>Actions</span></th>
                </tr>
              </thead>
              <tbody
                v-if="PRODUCT_ARTICLES.data && PRODUCT_ARTICLES.data.length > 0"
              >
                <tr
                  :class="article.active ? 'enabled' : 'inactive'"
                  v-for="article in PRODUCT_ARTICLES.data"
                  :key="article.id"
                >
                  <ArticleTable
                    :data="article"
                    :head="tableHeader"
                    :centeredColumns="centeredColumns"
                    @openActivity="openActivity"
                    @openTag="openTag"
                  />
                </tr>
              </tbody>
            </table>
          </div>
          <div
            v-if="PRODUCT_ARTICLES.length < 1"
            class="d-flex justify-content-center"
          >
            <div class="loader">Loading...</div>
          </div>
        </div>
        <div class="actions d-flex align-items-center">
          <label>{{ $t("actions") }}</label>
          <select v-model="action">
            <option :value="true">{{ $t("enabled") }}</option>
            <option :value="false">{{ $t("inactive") }}</option>
          </select>
          <button :disabled="applying" @click="applyAction">
            <span v-if="applying">{{ $t("applying") }}...</span>
            <span v-else>{{ $t("apply") }}</span>
          </button>
          <button class="ms-4" @click="openTagAddition = true">
            {{ $t("tags") }}
          </button>
          <div class="d-flex justify-content-end w-full">
            <div style="margin-right: 20px">
              <p class="list-summary">
                <select
                  v-model="limit"
                  v-on:change="onChange"
                  style="width: 67px"
                >
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </select>
                {{ $t("of") }} {{ PRODUCT_ARTICLES.total_resources }}
              </p>
            </div>
            <v-pagination
              v-model="PRODUCT_ARTICLES.page"
              :pages="PRODUCT_ARTICLES.total_pages"
              :range-size="1"
              active-color="#DCEDFF"
              @update:modelValue="changePageNumber"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <ModalBoxVue
    v-if="openArticleCustomizationModal"
    @handleClose="openArticleCustomizationModal = false"
    :close="!true"
  >
    <div class="container p-3">
      <p>Uppdatera ordningen på kolumnerna <small> (drag &amp; drop)</small></p>
      <!-- list all visible columns -->
      <div class="row small">
        <div class="col-md-12">
          <!-- draggable list of visible columns -->
          <ul class="list-group" id="sortlist">
            <li
              v-for="item in articleCustomizeItem"
              :key="item"
              class="list-group-item list-group-item-action"
              style="cursor: grab"
            >
              <div class="d-flex justify-content-start">
                <img
                  style="width: 20px; height: 20px; margin-right: 10px"
                  src="../../assets/images/icon-utility/drag-and-drop.svg"
                  alt="d&amp;d-icon"
                />
                <div>
                  <span>{{ $t(item) }}</span>
                </div>
              </div>
            </li>
          </ul>
          <!-- <div class="list-group" v-for="(item, i) in tableHeader" :key="i">
            <p
              class="list-group-item list-group-item-action"
              :class="{
                active: item == activeColumn,
                disabled: item_to_exclude.includes(item),
              }"
              @click="setActiveColumn(item)"
            >
              {{ $t(item) }}
            </p>
          </div> -->
        </div>
      </div>
    </div>
    <h4>{{ $t("customization_article") }}</h4>
    <div class="container p-3">
      <small>{{ $t("select_columns") }}</small>
      <form @submit.prevent="updateArticleCustomization">
        <div class="customize-cols-scrollar">
          <div
            class="form-check"
            v-for="(item, i) in Object.keys(ARTICLE_CUSTOMIZATION)"
            :key="i"
          >
            <input
              class="form-check-input"
              v-model="articleCustomizeItem"
              type="checkbox"
              :value="item"
            />
            <label class="form-check-label" for="flexCheckDefault">
              {{ ARTICLE_CUSTOMIZATION[item] }}
            </label>
          </div>
        </div>
        <div class="col-md-12 mt-2">
          <button type="submit" :disabled="updating" class="btn btn-primary">
            <span v-if="updating">{{ $t("updating") }}...</span>
            <span v-else>{{ $t("update") }}</span>
          </button>
        </div>
      </form>
    </div>
  </ModalBoxVue>
  <ModalBoxVue
    v-if="openTagAddition"
    @handleClose="openTagAddition = false"
    :close="!true"
  >
    <h4>{{ $t("tags") }}</h4>
    <div class="container p-3">
      <!-- <small>Select table heads (Multiple)</small> -->
      <div class="row">
        <div class="col-md-4 mb-4" v-for="(item, i) in articleTags" :key="i">
          <span
            class="position-absolute tags-box cursor-pointer"
            @click="removeTag(item.id)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              style="color: red"
              class="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                clip-rule="evenodd"
              />
            </svg>
          </span>
          <div class="border rounded p-2 bg-gray">
            <span class="d-flex align-items-center">
              <input
                class="form-check-input"
                :value="item.name"
                type="checkbox"
                v-model="tagSelection"
              />
              <small class="ml-2 tag-label">{{ item.name }}</small>
            </span>
          </div>
        </div>
      </div>
      <form class="row" @submit.prevent="addNewTags">
        <div class="col-md-8">
          <input
            class="form-control"
            v-model="tag"
            type="text"
            :placeholder="$t('add_tags')"
          />
        </div>
        <div class="col-md-4 d-flex justify-content-end">
          <button
            v-if="showAssignBtn"
            @click="assignTagArticles"
            :disabled="assigning"
            class="btn btn-success me-2 w-100"
          >
            <span v-if="assigning">{{ $t("assigning") }}...</span>
            <span v-else>{{ $t("assign") }}</span>
          </button>
          <button
            type="submit"
            :disabled="updating"
            class="btn btn-primary w-100"
          >
            <span v-if="updating">{{ $t("updating") }}...</span>
            <span v-else>{{ $t("save") }}</span>
          </button>
        </div>
      </form>
    </div>
  </ModalBoxVue>
</template>

<script>
import { mapGetters } from "vuex";
import debounce from "lodash.debounce";
import ArticleTable from "./reusableComponents/ArticleTable.vue";
import {
  ARTICLE_CUSTOMIZATION,
  ARTICLE_DEFAULT,
} from "./composables/customization";
import ModalBoxVue from "../../components/ModalBox.vue";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import AuthorizationBanner from "./reusableComponents/AuthorizationBanner";

export default {
  name: "ProductComponent",
  components: { ArticleTable, ModalBoxVue, VPagination, AuthorizationBanner },
  data() {
    return {
      item_to_exclude: ["tags"],
      tableHeader: [],
      articleCustomizeItem: [],
      articleTags: [],
      tagSelection: [],
      openArticleCustomizationModal: false,
      ARTICLE_CUSTOMIZATION: ARTICLE_CUSTOMIZATION,
      limit: 50,
      updating: false,
      openTagAddition: false,
      toggleChangeCheckbox: false,
      filter: null,
      tag: "",
      assigning: false,
      action: "",
      applying: false,
      showAssignBtn: false,
      syncing: false,
      selectedData: null,
      selectedFilter: "All",
      centeredColumns: ["reserved_quantity", "stock_value", "purchase_price"],
      orderByColumn: null, // which column to order
      orderByQuery: "",
      sortableColumns: [
        "active",
        "description",
        "sales_price",
        "purchase_price",
        "quantity_in_stock",
        "stock_value",
        "reserved_quantity",
        "expired",
        "webshop_article",
        "supplier_name",
        "disposable_quantity",
        "type",
        "freight_cost",
        "bulky",
        "stock_place",
      ],
    };
  },
  watch: {
    tagSelection: function (newVal, oldVal) {
      if (
        (this.selectedData && this.selectedData.article_number) ||
        (newVal.length > 0 && this.GET_ARTICLE_CHECKED.data.length > 0)
      ) {
        this.showAssignBtn = true;
      } else {
        this.showAssignBtn = false;
      }
    },

    openArticleCustomizationModal: function (val) {
      if (val) {
        setTimeout(() => {
          this.slist(document.getElementById("sortlist"));
        }, 200);
      }
    },

    articleCustomizeItem: function (val) {
      const list = document.getElementById("sortlist");
      if (list) {
        this.slist(list);
      }
    },
  },
  computed: {
    ...mapGetters({
      PRODUCT_ARTICLES: "clients/GET_ARTICLES",
      GET_ARTICLE_CHECKED: "clients/GET_ARTICLE_CHECKED",
      GET_PACKAGE: "clients/GET_PLAN_DETAIL",
      GET_USER_SUBSCRIPTION: "clients/GET_USER_SUBSCRIPTION",
      CURRENT_USER: "clients/GET_CURRENT_USER",
      ARTICLE_FILTER: "clients/GET_ARTICLE_FILTER",
    }),
  },
  mounted() {
    this.getUserSubscription();
    this.getProduct();
    this.getArticleTags();
    this.getArticleCustomizeHeader();
  },
  methods: {
    computeQueryParams() {
      if (Object.keys(this.ARTICLE_FILTER).length <= 0) {
        return null;
      }
      let payload = "";
      Object.keys(this.ARTICLE_FILTER).map((item) => {
        if (item === "filter") {
          this.selectedFilter = this.ARTICLE_FILTER[item];
          if (this.ARTICLE_FILTER[item] !== "all") {
            payload += `&filter=${this.ARTICLE_FILTER[item]}`;
          }
        } else {
          if (this.ARTICLE_FILTER[item]) {
            payload += `&${item}=${this.ARTICLE_FILTER[item]}`;
            if (item === "search") {
              document.getElementById("search").value =
                this.ARTICLE_FILTER[item];
            }
          }
        }
      });
      return payload;
    },
    getUserSubscription() {
      this.$store
        .dispatch("clients/getUserSubscription")
        .then((res) => {
          this.getPackageInfo();
        })
        .catch((err) => {});
    },
    getPackageInfo() {
      if (this.GET_USER_SUBSCRIPTION.length > 0) {
        if (
          !["free", "Free", "FREE"].includes(
            this.GET_USER_SUBSCRIPTION[0].current_package
          )
        ) {
          const payload = {
            URL:
              this.$services.endpoints.PACKAGE_ENDPOINT +
              `?package=${this.GET_USER_SUBSCRIPTION[0].current_package.toLowerCase()}`,
          };
          this.$store
            .dispatch("clients/getPlanDetails", payload)
            .then((res) => {
              if (
                !res.data.results[0].dashboard_page_access.includes(
                  this.$route.name
                )
              ) {
                window.Bus.emit("access-denied", "articles");
              }
            });
        } else {
          window.Bus.emit("access-denied", "articles");
        }
      } else {
        // FIXED: Don't recursively call getUserSubscription - this causes infinite loop
        // console.warn(
        //   "No subscriptions found for user - cannot load products page"
        // );
      }
    },
    syncProduct: function () {
      if (this.CURRENT_USER.access === "Read") {
        return this.$toast.info(this.$t("limited_read_access"));
      }
      this.syncing = true;
      this.$store
        .dispatch("clients/syncResource", "articles")
        .then(() => {
          this.syncing = false;
          this.$toast.info(this.$t("sync_articles"));
        })
        .catch((err) => {
          this.syncing = false;
          this.$toast.info(this.$t("fail_sync_articles"));
        });
    },
    onChange() {
      let payload = `limit=${this.limit}`;
      let params = this.computeQueryParams();
      if (params) {
        payload += params;
      }
      this.$store.dispatch("clients/getProduct", payload);
    },
    sortAscBy(index, item) {
      this.orderByColumn = item;
      this.orderByQuery = `&ordering=${this.orderByColumn}`;
      this.$store.commit("clients/UPDATE_ARTICLE_FILTER", { ordering: item });
      this.onChange();
    },
    sortDescBy(index, item) {
      this.orderByColumn = item;
      this.orderByQuery = `&ordering=-${this.orderByColumn}`;
      this.$store.commit("clients/UPDATE_ARTICLE_FILTER", {
        ordering: `-${item}`,
      });
      this.onChange();
    },
    searchField: debounce(function (event) {
      this.$store.commit("clients/UPDATE_ARTICLE_FILTER", {
        search: event.target.value,
      });
      this.onChange();
    }, 500),
    filterSearch(data) {
      this.filter = `search=${data}`;
      this.$store.commit("clients/UPDATE_ARTICLES", []);
      let payload = this.filter + `&limit=${this.limit}`;
      this.$store.dispatch("clients/getProduct", payload);
    },
    getProduct() {
      this.filter = null;
      this.selectedFilter = "All";

      this.$store.commit("clients/UPDATE_ARTICLES", []);
      const payload = `limit=${this.limit}` + this.orderByQuery;
      this.$store.dispatch("clients/getProduct", payload);
    },
    applyAction() {
      if (this.CURRENT_USER.access === "Read") {
        return this.$toast.info(this.$t("limited_read_access"));
      }
      if (this.action === "") {
        // this.$services.helpers.notification('Please select an action', 'error', this)
        this.$toast.warning(this.$t("choose_action"));
      } else if (this.GET_ARTICLE_CHECKED.data.length < 1) {
        // this.$services.helpers.notification('Please select a article(s)', 'error', this)
        this.$toast.warning(this.$t("choose_article"));
      } else {
        this.applying = true;

        const payload = {
          active: this.action,
          selected: this.GET_ARTICLE_CHECKED.data.map((item) => {
            return item.article_number;
          }),
        };
        this.$store
          .dispatch("clients/updateArticleStatus", payload)
          .then((res) => {
            this.applying = false;
            this.action = "";
            this.getProduct();
            // this.$store.commit('clients/TOGGLE_ALL_ARTICLE_CHECKBOX', false)
            // this.$services.helpers.notification('Updated article information', 'success', this)
            this.$toast.success(this.$t("updated_article_info"));
          })
          .catch((err) => {
            this.applying = false;
            this.$services.helpers.notification(
              err.response.data.message,
              "error",
              this
            );
          });
      }
    },
    getArticleTags() {
      this.$store
        .dispatch("clients/getTags", "ARTICLE")
        .then((res) => {
          this.articleTags = res.data.results;
        })
        .catch((err) => {});
    },
    changePageNumber(number) {
      let payload = `limit=${this.limit}&page=${number}`;
      let params = this.computeQueryParams();
      if (params) {
        payload += params;
      }
      this.$store.commit("clients/UPDATE_ARTICLES", []);
      this.$store.dispatch("clients/getProduct", payload + this.orderByQuery);
    },
    filterArticle(data) {
      this.selectedFilter = data;
      this.$store.commit("clients/UPDATE_ARTICLES", []);
      this.$store.commit("clients/UPDATE_ARTICLE_FILTER", { active: data });
      this.onChange();
    },
    toggleAllCheckbox(e) {
      this.$store.commit(
        "clients/TOGGLE_ALL_ARTICLE_CHECKBOX",
        this.toggleChangeCheckbox
      );
    },
    getArticleCustomizeHeader() {
      this.$store
        .dispatch("clients/getArticleCustomizeHeader")
        .then((res) => {
          this.tableHeader = res.data.data;
          if (this.tableHeader.length > 0) {
            this.articleCustomizeItem = this.tableHeader;
          } else {
            if (ARTICLE_DEFAULT) {
              Object.keys(ARTICLE_DEFAULT).forEach((el) => {
                this.articleCustomizeItem.push(el);
              });
            }
          }
        })
        .catch((err) => {});
    },
    openActivity(data) {
      // const array = []
      // this.GET_ARTICLE_CHECKED.data.forEach(element => {
      //     array.push(element.article_number)
      // })
      if (this.CURRENT_USER.access === "Read") {
        return this.$toast.info(this.$t("limited_read_access"));
      }
      const payload = {
        active: !data.active,
        selected: [data.article_number],
      };
      this.$store
        .dispatch("clients/updateArticleStatus", payload)
        .then((res) => {
          this.getProduct();
          // this.$store.commit('clients/TOGGLE_ALL_ARTICLE_CHECKBOX', false)
          // this.$services.helpers.notification('Updated article information', 'success', this)
          this.$toast.success(this.$t("updated_article_info"));
        })
        .catch((err) => {
          this.$services.helpers.notification(
            err.response.data.message,
            "error",
            this
          );
        });
    },
    openTag(data) {
      this.selectedData = data;
      this.openTagAddition = true;
    },
    updateArticleCustomization() {
      if (this.CURRENT_USER.access === "Read") {
        return this.$toast.info(this.$t("limited_read_access"));
      }
      if (this.articleCustomizeItem.length < 1) {
        // this.$services.helpers.notification('Please select columns', 'error', this)
        this.$toast.warning(this.$t("choose_columns"));
      } else {
        this.updating = true;
        this.$store
          .dispatch("clients/updateArticleCustomization", {
            columns: this.articleCustomizeItem,
          })
          .then((res) => {
            this.updating = false;
            this.openArticleCustomizationModal = false;
            this.getProduct();
            this.getArticleCustomizeHeader();
            this.$services.helpers.notification(
              res.data.message,
              "success",
              this
            );
          })
          .catch((err) => {
            this.updating = false;
            this.$services.helpers.notification(
              err.response.data.message,
              "error",
              this
            );
          });
      }
    },
    addNewTags() {
      if (this.CURRENT_USER.access === "Read") {
        return this.$toast.info(this.$t("limited_read_access"));
      }
      if (this.tag === "") {
        return;
      } else {
        this.updating = true;
        const payload = {
          type: "ARTICLE",
          name: this.tag,
        };
        this.$store
          .dispatch("clients/addTags", payload)
          .then((res) => {
            this.updating = false;
            this.getArticleTags();
          })
          .catch((err) => {
            this.updating = false;
            this.$services.helpers.notification(
              err.response.data.message,
              "error",
              this
            );
          });
      }
    },
    assignTagArticles() {
      if (this.CURRENT_USER.access === "Read") {
        return this.$toast.info(this.$t("limited_read_access"));
      }
      if (
        this.selectedData ||
        (this.GET_ARTICLE_CHECKED.data.length > 0 &&
          this.tagSelection.length > 0)
      ) {
        this.assigning = true;
        const array = [];
        this.GET_ARTICLE_CHECKED.data.forEach((element) => {
          if (element.article_number) {
            array.push(element.article_number);
          }
        });
        const payload = {};
        if (this.selectedData) {
          payload.tags = this.tagSelection;
          payload.selected = [this.selectedData.article_number];
        } else {
          payload.tags = this.tagSelection;
          payload.selected = array;
        }
        payload.URL = this.$services.endpoints.ARTICLE_ENDPOINT + "/bulktag";
        this.$store
          .dispatch("clients/assignBulkTag", payload)
          .then((res) => {
            this.assigning = false;
            this.tagSelection = [];
            this.openTagAddition = false;
            this.selectedData = null;
            this.$store.commit("clients/TOGGLE_ALL_ARTICLE_CHECKBOX", false);
            // this.$services.helpers.notification('Tag(s) assigned to article(s)', 'success', this)
            this.$toast.success(this.$t("tags_assigned"));
          })
          .catch((err) => {
            this.assigning = false;
            this.$services.helpers.notification(
              err.response.data.message,
              "error",
              this
            );
          });
      }
    },
    removeTag(data) {
      if (this.CURRENT_USER.access === "Read") {
        return this.$toast.info(this.$t("limited_read_access"));
      }
      this.$store
        .dispatch("clients/removeTags", data)
        .then((_) => {
          this.getArticleTags();
        })
        .catch((err) => {
          this.$services.helpers.notification(
            err.response.data.message,
            "error",
            this
          );
        });
    },
    slist(target) {
      // (A) SET CSS + GET ALL LIST ITEMS
      target.classList.add("slist");
      let items = target.getElementsByTagName("li"),
        current = null;

      // (B) MAKE ITEMS DRAGGABLE + SORTABLE
      for (let i of items) {
        // (B1) ATTACH DRAGGABLE
        i.draggable = true;

        // (B2) DRAG START - YELLOW HIGHLIGHT DROPZONES
        i.ondragstart = (ev) => {
          current = i;
          for (let it of items) {
            if (it != current) {
              it.classList.add("hint");
            }
          }
        };

        // (B3) DRAG ENTER - RED HIGHLIGHT DROPZONE
        i.ondragenter = (ev) => {
          if (i != current) {
            i.classList.add("active");
          }
        };

        // (B4) DRAG LEAVE - REMOVE RED HIGHLIGHT
        i.ondragleave = () => {
          i.classList.remove("active");
        };

        // (B5) DRAG END - REMOVE ALL HIGHLIGHTS
        i.ondragend = () => {
          for (let it of items) {
            it.classList.remove("hint");
            it.classList.remove("active");
          }
        };

        // (B6) DRAG OVER - PREVENT THE DEFAULT "DROP", SO WE CAN DO OUR OWN
        i.ondragover = (evt) => {
          evt.preventDefault();
        };

        // (B7) ON DROP - DO SOMETHING
        i.ondrop = (evt) => {
          evt.preventDefault();
          if (i != current) {
            let currentpos = 0,
              droppedpos = 0;
            for (let it = 0; it < items.length; it++) {
              if (current == items[it]) {
                currentpos = it;
              }
              if (i == items[it]) {
                droppedpos = it;
              }
            }

            if (currentpos < droppedpos) {
              i.parentNode.insertBefore(current, i.nextSibling);
            } else {
              i.parentNode.insertBefore(current, i);
            }

            let index = 0;
            const temp = [];
            for (let it of items) {
              let text = it.getElementsByTagName("span")[0].textContent;
              let textKey = this.articleCustomizeItem.find(
                (item) => this.$t(item) == text
              );
              // let textKeyIndex = this.articleCustomizeItem.indexOf(textKey);
              temp[index] = textKey;
              index++;
            }

            debounce(() => {
              for (let i = 0; i < temp.length; i++) {
                this.articleCustomizeItem[i] = temp[i];
              }
            }, 100)();
          }
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// TODO: change styling for active-filter class
.active-filter {
  box-shadow: 5px 5px 3px #888888 !important;
}

.content {
  padding: 10px 20px;
  padding-top: 90px;
  background-color: #f6f8fc;
}

.content .headers {
  margin: 30px 0 10px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.content .headers h1 {
  font-weight: 500;
  font-size: 24px;
  -webkit-transition: all 0.4s ease-out;
  -o-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
  line-height: 36px;
  color: #333269;
}

.content .headers h1:hover {
  background-color: #4947b0;
  color: #fff;
}

.list-summary {
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  margin-bottom: 0px;
  font-weight: 600;
}

.content .headers span {
  font-size: 16px;
  line-height: 24px;
  color: #333269;
}

.content .headers a svg path {
  -webkit-transition: fill 0.4s ease-out;
  -o-transition: fill 0.4s ease-out;
  transition: fill 0.4s ease-out;
}

.content .headers a:hover svg path {
  fill: #4946ae;
}

.content nav {
  margin: 20px 0 0 5px;
}

@media (max-width: 1094px) {
  .content nav .row {
    display: block;
  }
  .content nav .row > div:last-of-type {
    margin-top: 10px;
  }
  .content nav .row ul {
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
  .content nav .row ul li {
    margin-top: 5px;
    margin-bottom: 5px;
  }
}

.content nav ul {
  margin: 0;
  text-align: center;
  margin-top: 10px;
}

.content nav ul li {
  border-radius: 3.24215px;
  font-size: 14px;
  line-height: 32px;
  color: #ffffff;
  cursor: pointer;
  width: 100px;
  height: 32px;
  -webkit-transition: -webkit-transform 0.35s ease-in-out,
    -webkit-box-shadow 0.3s ease-in-out;
  transition: -webkit-transform 0.35s ease-in-out,
    -webkit-box-shadow 0.3s ease-in-out;
  -o-transition: transform 0.35s ease-in-out, box-shadow 0.3s ease-in-out;
  transition: transform 0.35s ease-in-out, box-shadow 0.3s ease-in-out;
  transition: transform 0.35s ease-in-out, box-shadow 0.3s ease-in-out,
    -webkit-transform 0.35s ease-in-out, -webkit-box-shadow 0.3s ease-in-out;
}

.content nav ul li:hover {
  -webkit-transform: translateY(-0.25em);
  -ms-transform: translateY(-0.25em);
  transform: translateY(-0.25em);
}

.content nav ul li.all {
  background: #c0beff;
}

.content nav ul li.all:hover {
  -webkit-box-shadow: 0 0.5em 0.5em -0.1em #c0beff;
  box-shadow: 0 0.5em 0.5em -0.1em #c0beff;
}

.content nav ul li.enabled {
  background: #419e6a;
}

.content nav ul li.enabled:hover {
  -webkit-box-shadow: 0 0.5em 0.5em -0.1em #419e6a;
  box-shadow: 0 0.5em 0.5em -0.1em #419e6a;
}

.el-clickable {
  cursor: pointer !important;
}

.content nav ul li.inactive {
  background: #efb008;
}

.content nav ul li.inactive:hover {
  -webkit-box-shadow: 0 0.5em 0.5em -0.1em #efb008;
  box-shadow: 0 0.5em 0.5em -0.1em #efb008;
}

.content nav ul li:not(:last-of-type) {
  margin-right: 15px;
}

.content nav .right-parent {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

@media (min-width: 1097px) {
  .content nav .right-parent {
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -moz-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
  }
}

.content nav .right-parent .filter {
  margin-right: 20px;
  margin-top: 10px;
}

.content nav .right-parent .filter label {
  font-size: 14px;
  line-height: 22px;
  color: #000000;
}

.content nav .right-parent .filter select {
  margin: 0 10px 0 10px;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  border: none;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.13);
  border-radius: 5px;
  padding-left: 7px;
  padding-right: 10px;
  height: 30px;
}

.content nav .right-parent .filter select:focus {
  outline: none;
}

.content nav .right-parent .filter button {
  background: #5855d6;
  border-radius: 4px;
  padding: 0 16px;
  border: none;
  color: #f6f8fc;
  font-size: 14px;
  line-height: 22px;
  height: 30px;
  -webkit-transition: all 0.4s ease-out;
  -o-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
}

.content nav .right-parent .filter button:hover {
  background-color: #4947b0;
  color: #fff;
}

@media (max-width: 767.98px) {
  .content nav .right-parent .filter {
    margin-top: 10px;
  }
}

@media (max-width: 575.98px) {
  .content nav .right-parent .filter {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .content nav .right-parent .filter * {
    margin: 5px !important;
  }
}

.content nav .right-parent .search {
  margin-right: 10px;
  margin-top: 10px;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  height: 30px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.13);
  border-radius: 5px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 290px;
}

@media (max-width: 767.98px) {
  .content nav .right-parent .search {
    margin-top: 10px;
  }
}

@media (max-width: 296px) {
  .content nav .right-parent .search {
    margin: 10px 0 0;
  }
}

.content nav .right-parent .search label {
  position: absolute;
  left: 0.5rem;
}

.content nav .right-parent .search input {
  border: none;
  width: 77%;
  margin-left: auto;
}

.content nav .right-parent .search input:focus {
  outline: none;
}

.content nav .right-parent .customize {
  margin-top: 10px;
}

@media (max-width: 767.98px) {
  .content nav .right-parent .customize {
    margin-top: 10px;
  }
}

@media (max-width: 296px) {
  .content nav .right-parent .customize {
    -webkit-flex-basis: 100%;
    -ms-flex-preferred-size: 100%;
    flex-basis: 100%;
  }
}

.content nav .right-parent .customize a {
  font-size: 14px;
  line-height: 22px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #5855d6;
  text-decoration: none;
  -webkit-transition: color 0.4s ease-out;
  -o-transition: color 0.4s ease-out;
  transition: color 0.4s ease-out;
}

.content nav .right-parent .customize a svg {
  margin-right: 10px;
}

.content nav .right-parent .customize a svg path {
  -webkit-transition: fill 0.4s ease-out;
  -o-transition: fill 0.4s ease-out;
  transition: fill 0.4s ease-out;
}

.content nav .right-parent .customize a:hover {
  color: #4946ae;
}

.content nav .right-parent .customize a:hover svg path {
  fill: #4946ae;
}

.content .box {
  background: #ffffff;
  -webkit-box-shadow: 0px 2.93422px 4.89036px rgba(9, 30, 66, 0.2),
    0px 0px 0.978073px rgba(9, 30, 66, 0.31);
  box-shadow: 0px 2.93422px 4.89036px rgba(9, 30, 66, 0.2),
    0px 0px 0.978073px rgba(9, 30, 66, 0.31);
  border-radius: 3.91229px;
  margin-top: 20px;
}

.content .box table {
  width: 100%;
  text-align: center;
  min-width: 970px;
}

.content .box table .checkbox {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -moz-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.content .box table .checkbox input {
  border: 0.978073px solid #64748b;
  border-radius: 3.91229px;
  height: 15px;
  width: 15px;
  position: relative;
  z-index: 33;
  background: #fffbfb;
  cursor: pointer;
  -webkit-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.content .box table .checkbox input:checked {
  border: none;
  background: transparent;
}

.content .box table .checkbox input,
.content .box table .checkbox input:checked {
  -moz-appearance: none;
  -webkit-appearance: none;
  -o-appearance: none;
}

.content .box table .checkbox input:checked ~ svg {
  display: block;
}

.content .box table .checkbox svg {
  position: absolute;
  height: 17px;
  width: 17px;
  display: none;
  z-index: 1;
  -webkit-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.content .box table .checkbox svg span {
  cursor: pointer;
  display: inline-block;
  margin: 0 5px;
}

.content .box table thead th {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #000000;
  padding-top: 20px;
  padding-bottom: 20px;
}

.content .box table thead th:first-of-type {
  padding-left: 10px;
}

.content .box table thead th:last-of-type {
  padding-right: 10px;
}

.content .box table thead th.editable {
  width: 155px;
}

.content .box table thead th span {
  cursor: pointer;
  display: inline-block;
  margin: 0 5px;
}

.content .box table tbody tr:first-of-type {
  border-top: 0.982163px solid rgba(0, 0, 0, 0.13);
}

.content .box table tbody tr:nth-child(odd) {
  background: #f1f4f9;
}

.content .box table tbody tr {
  -webkit-transition: background 0.2s ease-out;
  -o-transition: background 0.2s ease-out;
  transition: background 0.2s ease-out;
}

.content .box table tbody tr:hover {
  background-color: #f8fbff !important;
}

.content .box table tbody tr.enabled td a {
  color: #419e6a;
}

.content .box table tbody tr.inactive td a {
  color: #efb008;
}

.content .box table tbody td {
  font-size: 14px;
  line-height: 22px;
}

.content .box table tbody td a {
  text-decoration: none;
  display: block;
  color: #000;
  padding: 10px 5px;
}

.content .box table tbody td span.retail-price,
.content .box table tbody td span.purchase-price,
.content .box table tbody td span.in-stock,
.content .box table tbody td input.retail-price,
.content .box table tbody td input.purchase-price,
.content .box table tbody td input.in-stock {
  color: #000;
  width: 100px;
  height: 26px;
  background: #f0eff5;
  border: 1px solid #c8c7cd;
  line-height: 26px;
  display: block;
  margin: 0 auto;
}

.content .box table tbody td:first-of-type {
  padding-left: 10px;
}

.content .box table tbody td:last-of-type {
  padding-right: 10px;
}

.content .box table tbody td .editable {
  padding: 10px 5px;
}

.content .box table tbody td .editable input {
  background: #f0eff5;
  border: 1px solid #c8c7cd;
  padding: 2px 12px;
  width: 100px;
  text-align: center;
}

.content .box table tbody td .editable input:focus {
  border: 1px solid #c8c7cd;
  outline: none;
}

.content .box table tbody td .editable input.lower {
  border-color: #fb4b4b;
  background: #fb4b4b;
  color: #fff;
}

.content .box table tbody td button {
  background: transparent;
  border: none;

  .content {
    padding: 10px 20px;
    padding-top: 90px;
    background-color: #f6f8fc;
  }

  .content .headers {
    margin: 30px 0 10px;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -moz-box-orient: vertical;
    -moz-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .content .headers h1 {
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    color: #333269;
  }

  .content .headers h1 ~ h6 {
    font-size: 16px;
    line-height: 24px;
    color: #333269;
    font-weight: 400;
  }

  .content .product-showcase {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    background: #fffdfd;
    -webkit-box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
      0px 0px 1px rgba(9, 30, 66, 0.31);
    box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
      0px 0px 1px rgba(9, 30, 66, 0.31);
    border-radius: 5px;
    padding: 20px 30px;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin: 20px 0 35px;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }

  @media (max-width: 638px) {
    .content .product-showcase {
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -moz-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
    }
  }

  .content .product-showcase h2 {
    font-weight: bold;
    font-size: 20px;
    line-height: 30px;
    color: #333269;
    margin: 0;
  }

  .content .product-showcase ul {
    margin: 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    background: #333269;
    padding: 10px;
    -webkit-box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
      0px 0px 1px rgba(9, 30, 66, 0.31);
    box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
      0px 0px 1px rgba(9, 30, 66, 0.31);
    border-radius: 4px;
    text-align: center;
  }

  .content .product-showcase ul li a {
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    border-radius: 4px;
    text-decoration: none;
    color: #d2d1d7;
    display: inline-block;
    padding: 8px 25px;
  }

  .content .product-showcase ul li:first-of-type a {
    margin-right: 10px;
    padding-right: 10px;
  }

  .content .product-showcase ul li:last-of-type a {
    margin-left: 10px;
    padding-left: 10px;
  }

  .content .product-showcase ul li.active a {
    background: #f6f8fc;
    color: #333269;
    padding: 9px 25px;
  }

  .content .product-showcase ul p:first-of-type {
    margin-right: 20px;
  }

  .content .box {
    background: #fffdfd;
    -webkit-box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
      0px 0px 1px rgba(9, 30, 66, 0.31);
    box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
      0px 0px 1px rgba(9, 30, 66, 0.31);
    border-radius: 5px;
    margin-top: 20px;
    height: 100%;
  }

  .content .box.product h3 {
    background-image: url("./../../assets/images/table/product.png");
    background-repeat: no-repeat;
    background-position: center right;
  }

  .content .box.price h3 {
    background-image: url("./../../assets/images/table/price.png");
    background-repeat: no-repeat;
    background-position: center right;
  }

  .content .box.account h3 {
    background-image: url("./../../assets/images/table/account.png");
    background-repeat: no-repeat;
    background-position: center right;
  }

  .content .box h3 {
    background: #5855d6;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    color: #fffdfd;
    padding: 30px;
    border-radius: 5px 5px 0px 0px;
    margin: 0;
  }

  .content .box form {
    padding: 30px;
  }

  .content .box form .desc {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #000000;
    margin-bottom: 20px;
  }

  .content .box form .desc input:-moz-read-only {
    background: #c8c7cd;
  }

  .content .box form .desc input:read-only {
    background: #c8c7cd;
  }

  .content .box form .desc label {
    margin-bottom: 10px;
    display: block;
  }

  .content .box form .desc input,
  .content .box form .desc select {
    background: #f0eff5;
    -webkit-box-shadow: 0px 1px 1px rgba(9, 30, 66, 0.25),
      0px 0px 1px rgba(9, 30, 66, 0.31);
    box-shadow: 0px 1px 1px rgba(9, 30, 66, 0.25),
      0px 0px 1px rgba(9, 30, 66, 0.31);
    border-radius: 4px;
    border: none;
    height: 24px;
    width: 192px;
    text-indent: 10px;
    padding-right: 5px;
  }

  .content .box form .desc input.small,
  .content .box form .desc select.small {
    width: 95px;
  }

  .content .box form .desc input:focus,
  .content .box form .desc select:focus {
    outline: none;
  }

  .content .box form .desc .radio {
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: -moz-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    background: #333269;
    border-radius: 4px;
    color: #d2d1d7;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 1px;
  }

  .content .box form .desc .radio input {
    display: none;
  }

  .content .box form .desc .radio input:checked + label {
    background: #f6f8fc;
    color: #000000;
  }

  .content .box form .desc .radio label {
    margin: 0;
    cursor: pointer;
    padding: 1px 11.5px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    -webkit-transition: all 0.3s ease-out;
    -o-transition: all 0.3s ease-out;
    transition: all 0.3s ease-out;
    border-radius: 4px;
  }

  .content .box form .desc .radio label:first-of-type {
    margin-right: 10px;
  }

  .content .box form textarea {
    background: #f0eff5;
    width: 176px;
    height: 100px;
    -webkit-box-shadow: 0px 1px 1px rgba(9, 30, 66, 0.25),
      0px 0px 1px rgba(9, 30, 66, 0.31);
    box-shadow: 0px 1px 1px rgba(9, 30, 66, 0.25),
      0px 0px 1px rgba(9, 30, 66, 0.31);
    border-radius: 4px;
    resize: none;
    border: none;
  }

  .content .box form textarea:focus {
    border: none;
    outline: none;
  }

  .content .box table {
    width: 94%;
    margin: 40px auto;
    background: #fff;
    text-align: center;
    -webkit-box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
      0px 0px 1px rgba(9, 30, 66, 0.31);
    box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
      0px 0px 1px rgba(9, 30, 66, 0.31);
    border-radius: 5px;
  }

  .content .box table thead th {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 18px;
    color: #000000;
    background: #f6f8fc;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .content .box table thead th:nth-of-type(1),
  .content .box table thead th:nth-of-type(2) {
    text-align: left;
    padding-left: 15px;
  }

  .content .box table thead th:nth-of-type(2) {
    padding-right: 80px;
  }

  .content .box table thead th:last-of-type {
    padding-right: 15px;
  }

  .content .box table tbody tr {
    position: relative;
  }

  .content .box table tbody tr:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: #cbd4e1;
    left: 0;
    bottom: 0;
  }

  .content .box table tbody tr td {
    vertical-align: middle;
    padding: 10px 15px;
    position: relative;
    font-size: 12px;
    line-height: 18px;
    color: #000000;
  }

  .content .box table tbody tr td:nth-of-type(2) {
    text-align: left;
    padding-left: 15px;
  }

  .content .box table tbody tr td:nth-of-type(2) input {
    margin: 0;
  }

  .content .box table tbody tr td input {
    background: #e6e5eb;
    -webkit-box-shadow: 0px 1px 1px rgba(9, 30, 66, 0.25),
      0px 0px 1px rgba(9, 30, 66, 0.31);
    box-shadow: 0px 1px 1px rgba(9, 30, 66, 0.25),
      0px 0px 1px rgba(9, 30, 66, 0.31);
    border-radius: 4px;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: #000000;
    height: 22px;
    border: none;
    display: block;
    padding: 1px 5px;
    margin: 0 auto;
  }

  .content .box table tbody tr td input:focus {
    border: none;
    outline: none;
  }

  .content .box table tbody tr td input.big {
    max-width: 188px;
  }

  .content .box table tbody tr td input.mid {
    max-width: 64px;
  }

  .content .box table tbody tr td:after {
    content: "";
    position: absolute;
    width: 1px;
    height: 100%;
    background-color: #cbd4e1;
    right: 0;
    top: 0;
  }

  .content .box button {
    background: #5855d6;
    width: 126px;
    height: 47px;
    -webkit-box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
      0px 0px 1px rgba(9, 30, 66, 0.31);
    box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2),
      0px 0px 1px rgba(9, 30, 66, 0.31);
    border-radius: 4px;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: #ffffff;
    border: none;
    margin-bottom: 30px;
    margin-left: 3%;
    -webkit-transition: all 0.4s ease-out;
    -o-transition: all 0.4s ease-out;
    transition: all 0.4s ease-out;
  }

  .content .box button:hover {
    background-color: #4947b0;
    color: #fff;
  }

  .content .buttons {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    margin: 50px 0 40px;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -moz-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
  }

  .content .buttons button,
  .content .buttons a {
    padding: 0.6rem 1.1rem;
    border-radius: 4px;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }

  .content .buttons a {
    border: 1px solid #64748b;
    color: #64748b;
    background: #f6f8fc;
    text-decoration: none;
    -webkit-transition: all 0.4s ease-out;
    -o-transition: all 0.4s ease-out;
    transition: all 0.4s ease-out;
  }

  .content .buttons a:hover {
    color: #4b5768;
    border-color: #4b5768;
    background-color: #eaf0fa;
  }

  .content .buttons button {
    background: #5855d6;
    color: #f6f8fc;
    border: none;
    margin-left: 10px;
    -webkit-transition: all 0.4s ease-out;
    -o-transition: all 0.4s ease-out;
    transition: all 0.4s ease-out;
  }

  .content .buttons button:hover {
    background-color: #4947b0;
    color: #fff;
  }

  padding: 0;
}

.content .box table tbody td button svg path {
  -webkit-transition: fill 0.4s ease-out;
  -o-transition: fill 0.4s ease-out;
  transition: fill 0.4s ease-out;
}

.content .box table tbody td button:hover svg path {
  fill: #4946ae;
}

.content .actions {
  margin-top: 30px;
  margin-bottom: 20px;
}

.content .actions label {
  font-size: 14px;
  line-height: 22px;
  color: #000000;
}

.content .actions select {
  margin: 0 15px 0 10px;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  border: none;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.13);
  border-radius: 5px;
  padding-left: 7px;
  padding-right: 10px;
  height: 30px;
}

.content .actions select:focus {
  outline: none;
}

.content .actions button {
  background: #5855d6;
  border-radius: 4px;
  padding: 0 16px;
  border: none;
  color: #f6f8fc;
  font-size: 14px;
  line-height: 22px;
  height: 30px;
  -webkit-transition: all 0.4s ease-out;
  -o-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
}

.content .actions button:hover {
  background-color: #4947b0;
  color: #fff;
}

.sync-btn {
  height: 30px;
  width: 31px;
  position: relative;
  margin-left: 10px;
}

.sync-btn i {
  position: absolute;
  top: 3px;
  left: 4px;
  font-size: 20px !important;
}

.content {
  padding: 90px 30px 10px !important;
}
</style>
